// extracted by mini-css-extract-plugin
module.exports = {"social":"socialcontacts-module--social--2DDTF","link":"socialcontacts-module--link--1FEFL link--genericlink--3PIXe"};